import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectPeopleArray } from 'services/people/selectors';

// Utils
import orderBy from 'utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFilteredData = createDeepEqualSelector(
    selectPeopleArray,
    peopleArrayState => peopleArrayState.filter(value => value.email)
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'fullName')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ email, fullName }) => ({
            key: email,
            text: fullName,
            value: email
        }))
);

export { selectOptions };
